module.exports = __webpack_public_path__ + "static/img/miaozhun.4472ee14.jpg";